/**
 * Compliance Calendar feature identity (design v7, §5.2).
 *
 * Imported by both sides; the name/key facts exist once. Single-key module:
 * every registration and route attributes implicitly.
 */

import { defineIdentity, type FeatureIdentity } from '../featureModule'

export const identity: FeatureIdentity = defineIdentity({
  name: 'compliance_calendar',
  entitlements: ['compliance_calendar'],
})
